import { useGlobalState } from '@/hooks';
import { ShipmentSelector } from '@/modules/pmt/components/ShipmentSelector';
import { ALLOWED_FILTER_TO_SORT, MAPPED_TRANSLATION_SORT_OPTIONS } from '@/modules/pmt/constants';
import { useShipmentFiltersContext, useShipmentsOverviewContext } from '@/modules/pmt/context';
import { gtmClickSort } from '@/utils';
import SortIcon from '../../../../../../../public/images/icons/sort.svg';
import { FilterChip } from '../FilterChip';

export const ShipmentSort = () => {
  const { t } = useGlobalState();
  const { filterConfig, updateCurrentSort } = useShipmentFiltersContext();
  const { shipmentsQty } = useShipmentsOverviewContext();

  const translatedSortOptions = Object.values(ALLOWED_FILTER_TO_SORT[filterConfig.currentFilter]).map((value) => ({
    label: t(MAPPED_TRANSLATION_SORT_OPTIONS[value]),
    value,
  }));

  const translatedSelectedOptionLabel = t(MAPPED_TRANSLATION_SORT_OPTIONS[filterConfig.currentSort]);

  return (
    <div style={{ width: '100%' }}>
      <ShipmentSelector
        options={translatedSortOptions}
        value={filterConfig.currentSort}
        onValueChange={(value) => {
          gtmClickSort({ sort: value, parcelQty: shipmentsQty ?? 0 });
          updateCurrentSort(value);
        }}
        renderTrigger={() => <FilterChip label={translatedSelectedOptionLabel} icon={SortIcon} />}
      />
    </div>
  );
};
